/* eslint-disable no-nested-ternary */
/* eslint-disable no-shadow */
/* eslint-disable */
import { useEffect, useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router';
import { func } from 'prop-types';
import { connect } from 'react-redux';
import SearchBar from '../../Components/SearchBar/SearchBar';
import styles from './ListPage.module.scss';
import { Button } from '@/Components/ui/button';
import { useAuth } from '@/Components/Auth/Login/auth';
import authActions from '@/Actions/auth.actions';

const CREATE_EXCLUSIONS = [
	'STORE_SETTINGS',
	'PRINTER_CONFIG',
	'VARIANTS',
	'SUBSCRIPTION',
	'NUTRITION',
	'COOKING_PRODUCT_CONFIG',
	'APPROVE_REFUNDS',
	'REFUND_HISTORY',
	// 'REQUEST_REFUND',
	'PAYMENT_SETTLEMENTS',
	'CUSTOMIZATIONS',
	'MY_CUSTOMERS',
	'INVENTORY CONFIG',
	'QUALITY CONFIG',
	'SKU STOCK REPORT',
];

const MASTER_CREATION_EXCLUSIONS = [
	'COMBOS',
	'MASTER MENU',
	"ASSET TYPE",
];

const HEADER_EXCLUSIONS = ['QUALITY_SETTING', 'VENDORS'];

const ListPage = (props) => {
	const {
		entity,
		ListComponent,
		placeholder,
		listPageProps,
		listFilter,
		searchBy,
		userPermissions,
		searchOnClick = false,
		header = false,
		listHeader = '',
		headerName = '',
		type,
		showSearchBar = true,
		navState,
		userList,
		fetchUserList,
	} = props;
	const { url } = useRouteMatch();
	const { userConfig = {}, appConfig = {} } = useAuth();
	const { userRolesDict = {} } = userConfig || {};
	const isInternal = Object?.values?.(userRolesDict ?? {}).some(role => role.toLowerCase().includes('internal'));
	const {
		masterCreation = true,
	} = appConfig?.configs ?? {};



	const { level } = userConfig?.userDetails || {};
	const history = useHistory();
	const [state, setState] = useState(() => {
		return {
			query: '',
			searchField: searchBy?.options?.[0] != null ? 0 : null,
		};
	});
	const [dummyQuery, setDummyQuery] = useState('');

	const navigateToAddItem = () => {
		history.push(`${url}/new`);
	};

	const handleInput = (query) => {
		if (searchOnClick) {
			setDummyQuery(query);
		} else {
			setState({
				...state,
				query,
			});
		}
	};

	const handleChange = (searchField) => {
		setState({
			...state,
			searchField,
		});
	};

	const handleClickSearch = () => {
		setState({
			...state,
			query: dummyQuery,
		});
	};

	const masterDisallowedCreation=!((!isInternal && masterCreation)||(isInternal)) && MASTER_CREATION_EXCLUSIONS.indexOf(entity) === -1
	return (
		<div className={`${styles['list-view-root']} page`}>
			{listHeader && (
				<div className='w-full pt-3 px-4'>
					<p className='text-lg font-semibold'>{listHeader}</p>
				</div>
			)}
			{HEADER_EXCLUSIONS.indexOf(entity) === -1 && (
				<div className={`${styles['list-view-header']}`}>
				{showSearchBar && (
					searchOnClick ? (
						<div style={{
							display: 'flex',
							width: '100%',
							justifyContent: 'space-around',
						}}
						>
							<SearchBar
								handleInput={handleInput}
								handleChange={handleChange}
								searchBy={
									searchBy != null
										? {
											...(searchBy ?? {}),
											current: state.searchField,
										}
										: null
								}
								placeholder={placeholder}
							/>
							<Button
								className='ml-2.5 primary-btn'
								onClick={handleClickSearch}
							>
								Find
							</Button>
						</div>
					) : (
						<div className='search-bar'>
							{header === true ? <p className='text-xl font-medium'>{headerName}</p> : (
								<SearchBar
									handleInput={handleInput}
									handleChange={handleChange}
									searchBy={
										searchBy != null
											? {
												...(searchBy ?? {}),
												current: state.searchField,
											}
											: null
									}
									placeholder={placeholder}
								/>
							)}
						</div>
					))}

					{listFilter && (
						<div className={styles.filter}>{listFilter}</div>
					)}
					{level !== 1 &&
						CREATE_EXCLUSIONS.indexOf(entity) === -1 && (
						<div className='relative'>
						<Button
							// variant='contained'
							// color='primary'
							
							className={`bg-uy-color text-black hover:bg-[#e0a103] ${masterDisallowedCreation ? 'opacity-50 bg-gray-300' : ''}`}
							onClick={navigateToAddItem}
							disabled={masterDisallowedCreation}
						>
							{entity === 'Quote' ? 'Raise RFQ' : `+ ADD ${entity}`}
						</Button>
							{masterDisallowedCreation && (
								<div className='absolute z-10 -bottom-4 w-full flex items-center justify-center '>
									<p className='text-red-500 text-[10px] text-nowrap whitespace-nowrap'>Direct creation not allowed</p>
								</div>
							)}
						</div>
					)}
				</div>
			)}
			<ListComponent
				query={state.query}
				listPageProps={listPageProps}
				searchBy={searchBy?.options?.[state?.searchField]}
				type={type}
			/>
		</div>
	);
};
ListPage.defaultProps = {
	placeholder: 'Search By Name',
};

const mapStateToProps = (state) => {
	const {userPermissions} = state.navigation;
	const { userList } = state.auth;
	return {
		userList,
		userPermissions,
	};
};

const mapDispatchToProps = {
	fetchUserList: authActions?.fetchUserList,
};

export default connect(mapStateToProps, mapDispatchToProps)(ListPage);
